import { doc, updateDoc } from "firebase/firestore";
import db from "@/firebase/db";
import auth from "@/firebase/auth";
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  sendEmailVerification,
  updateEmail,
  updatePassword,
  updateProfile,
} from "firebase/auth";

export default async function updateUser(
  { commit },
  payload = {
    newDisplayName: null,
    newTitle: null,
    currentPassword: null,
    newEmailAddress: null,
    newPassword: null,
  }
) {
  if (payload.newDisplayName) {
    await updateProfile(auth.currentUser, {
      displayName: payload.newDisplayName,
    }).catch((error) => {
      throw error;
    });
    await commit("SET_USER", {
      displayName: payload.newDisplayName,
    });
  }

  if (payload.newTitle) {
    await updateDoc(doc(db, "users", auth.currentUser.uid), {
      title: payload.newTitle,
    }).catch((error) => {
      throw error;
    });
    await commit("SET_USER", {
      title: payload.newTitle,
    });
  }

  if (payload.currentPassword && payload.newEmailAddress) {
    await reauthenticateWithCredential(
      auth.currentUser,
      EmailAuthProvider.credential(
        auth.currentUser.email,
        payload.currentPassword
      )
    ).catch((error) => {
      throw error;
    });

    await updateEmail(auth.currentUser, payload.newEmailAddress).catch(
      (error) => {
        throw error;
      }
    );

    await sendEmailVerification(auth.currentUser).catch((error) => {
      throw error;
    });

    await commit("SET_USER", {
      email: payload.newEmailAddress,
      emailVerified: false,
    });
  }

  if (payload.currentPassword && payload.newPassword) {
    await reauthenticateWithCredential(
      auth.currentUser,
      EmailAuthProvider.credential(
        auth.currentUser.email,
        payload.currentPassword
      )
    ).catch((error) => {
      throw error;
    });

    await updatePassword(auth.currentUser, payload.newPassword).catch(
      (error) => {
        throw error;
      }
    );
  }
}
